import React from 'react'
import ReactDOMServer from 'react-dom/server'
import { l } from '@manychat/manyui'

import { formatWeekdays } from 'utils'
import { isFormulaContainsOffset, parseOffsetFormula } from 'common/actions/models/Action/helpers'
import { ISmartDelayNode } from 'common/builder/nodes/nodeInterfaces'
import { DelayType } from 'common/builder/nodes/smartDelay/delayTypes'
import { formatDateTime } from 'common/usesList/utils'
import { VAR_REGEX } from 'constants/RegExs'

export const UNITS_LABELS: Record<string, () => string> = {
  seconds: l.makeTranslate('Seconds'),
  minutes: l.makeTranslate('Minutes'),
  hours: l.makeTranslate('Hours'),
  days: l.makeTranslate('Days'),
}

export const DelayTypeLabel: Record<DelayType, () => string> = {
  [DelayType.DURATION]: l.makeTranslate('Duration'),
  [DelayType.WAIT_UNTIL]: l.makeTranslate('Date'),
}

export enum SmartDelayWaitUntilOperation {
  SET_TO_CUF = 'SET_TO_CUF',
  SET_TO_SPECIFIC_DATE = 'SET_TO_SPECIFIC_DATE',
}

export const OPERATIONS = [
  {
    value: SmartDelayWaitUntilOperation.SET_TO_CUF,
    label: l.makeTranslate('Dynamic date'),
  },
  {
    value: SmartDelayWaitUntilOperation.SET_TO_SPECIFIC_DATE,
    label: l.makeTranslate('Specific date'),
  },
]

// TODO: refactor https://youtrack.manychat.io/issue/TD-145
export function formatDelay(
  node: ISmartDelayNode,
  wrapValue?: (value: string) => string,
  timezone?: string | null,
) {
  if (node.delayType === DelayType.WAIT_UNTIL) {
    if (node.waitUntil.is_formula) {
      if (isFormulaContainsOffset(node.waitUntil.value)) {
        const [operator, offsetValue, unit] = parseOffsetFormula(node.waitUntil.value)

        const parsedFromFormula = VAR_REGEX.exec(node.waitUntil.value) || []
        VAR_REGEX.lastIndex = 0
        const newValue = `${parsedFromFormula[1]}`

        return `<b>Wait Until </b> {{${newValue}}} ${operator} ${offsetValue} ${unit}`
      }

      return `<b>Wait Until </b> ${node.waitUntil.value}`
    }

    return `<b>Wait Until </b> <secondary>${formatDateTime(
      node.waitUntil.value,
      false,
      timezone,
    )}</secondary>`
  }

  const isSingular = `${node.delayValue}` === '1'
  let label = l.getString(UNITS_LABELS[node.delayUnits as string])
  if (isSingular) {
    label = label.slice(0, -1)
  }

  let value = `${node.delayValue} ${label}`
  if (typeof wrapValue === 'function') {
    value = wrapValue(value)
  }

  if (!node.useTimeWindow) {
    return ReactDOMServer.renderToStaticMarkup(
      l.translate('Wait {value} \u00A0and then continue', {
        value,
      }) as unknown as React.ReactElement,
    )
  }

  let result = ReactDOMServer.renderToStaticMarkup(
    l.translate('Wait at least {value} \u00A0and then continue', {
      value,
    }) as unknown as React.ReactElement,
  )

  const weekdays = formatWeekdays(node.weekdays, true)

  let limit = l.translate(' at {startHour}:00-{endHour}:00', {
    startHour: node.sendingInterval[0],
    endHour: node.sendingInterval[1],
  })

  if (weekdays) {
    limit = l.translate(' at {startHour}:00-{endHour}:00 on {weekdays}', {
      startHour: node.sendingInterval[0],
      endHour: node.sendingInterval[1],
      weekdays,
    })
  }

  result += limit

  return result
}
